import React from "react";
import "./ModalCardTwo.css";

const ModalCardTwo = ({ heading, pic }) => {
  return (
    <div className="modal-card-two">
      <div className="modal-card-two-img-container">
        <img src={pic} alt={heading} className="modal-card-two-img" />
      </div>
      <h3 className="modal-card-two-heading">{heading}</h3>
    </div>
  );
};

export default ModalCardTwo;
